module.exports = __webpack_public_path__ + "img/warning-icon.5bacec8e.svg";